export default __webpack_public_path__ + "types-of-facilities-section.png";